import api from '@/api';

const resource = 'atena/usuario';

export default {
  getListaUsuarios(data) {
    return api.get(`${resource}`, {
      params: data,
    });
  },
  getUsuario(id) {
    return api.get(`${resource}/${id}`);
  },
  postUsuario(data) {
    return api.post(`${resource}`, data);
  },
  putUsuario(data) {
    return api.put(`${resource}/${data.identificadorusuario}`, data);
  },
  getUsuarioPerfis(id) {
    return api.get(`${resource}/${id}/perfil`);
  },
  getUsuarioPerfil(id, idPerfil) {
    return api.get(`${resource}/${id}/perfil/${idPerfil}`);
  },
  postUsuarioPerfil(data) {
    return api.post(`${resource}/${data.identificadorusuario}/perfil`, data);
  },
  putUsuarioPerfil(data) {
    return api.put(`${resource}/${data.identificadorusuario}/perfil/${data.identificadorusuarioperfil}`, data);
  },
  deleteUsuarioPerfil(id, idPerfil) {
    return api.delete(`${resource}/${id}/perfil/${idPerfil}`);
  },
};